import weatherRoutingAxiosInstance from "../../services/weather_routing_axios_instance";
import portFromJson from "../../domain/weather_routing/port/mapper";
import getKNearestPorts from "../../helper_functions/distance";

const localWeatherRoutingServerUrl = process.env.VUE_APP_LOCAL_WR_API_URL;

const state = {
  ports: [],
  nearestPorts: [],
  fetchLoading: true,
  fetchError: null,
};

const getters = {

};

const mutations = {
  SET_PORT_FETCH_LOADING_STATE: (state) => {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_PORT_FETCH_ERROR: (state, error) => {
    state.fetchError = error;
    state.fetchLoading = false;
  },
  SET_PORT_FETCH_SUCCESS: (state, ports) => {
    state.ports = ports;
    state.fetchLoading = false;
    state.fetchError = null;
  },
  SET_NEAREST_PORTS: (state, ports) => {
    state.nearestPorts = ports;
  },
};

const actions = {

  async fetchPorts({ commit, rootState }) {
    commit("SET_PORT_FETCH_LOADING_STATE");
    try {
      const response = await weatherRoutingAxiosInstance.get(
        `${localWeatherRoutingServerUrl}/port`,
        {
          headers: {
            "theyr-token": `${rootState.weatherRouting.weatherRoutingAccessToken}`,
            "access-token": localStorage.getItem("quad_token"),
          }
        }
      );

      if (response.status === 200) {
        const ports = response.data.map((json) => portFromJson(json));
        commit("SET_PORT_FETCH_SUCCESS", ports);
      }
    } catch (error) {
      commit("SET_PORT_FETCH_ERROR", error);
    }
  },

  async findKNearestPorts({ commit, rootState }, payload) {
    const K = payload.K;
    try {
      const ports = getKNearestPorts(
        rootState.weatherRouting.currentVesselCoordinates.Latitude,
        rootState.weatherRouting.currentVesselCoordinates.Longitude,
        state.ports,
        K
      );
      commit("SET_NEAREST_PORTS", ports);
    } catch (error) {
      commit("SET_NEAREST_PORTS", []);
    }
  },

  async fetchPortsData({ dispatch }) {
    try {
      if (state.ports.length === 0) {
        await dispatch("fetchPorts");
      }
      dispatch("findKNearestPorts", {
        K: 5,
      });
    } catch (error) {
      //console.error("Error fetching port locations:", error);
    }
  }
};

export const weatherRoutingPortModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
